import type { Icon as PhosphorIcon } from '@phosphor-icons/react';
import { iconSizes } from '@mybusinessmate/ui-tokens';

export type IconSize = Exclude<keyof typeof iconSizes, 'strokeWidth'>;

export interface IconProps {
  /** A Phosphor icon component, e.g. `import { ArrowRight } from '@phosphor-icons/react'`. */
  icon: PhosphorIcon;
  size?: IconSize;
  /** Defaults to `currentColor` so it follows a `text-*` Tailwind class on an ancestor. */
  color?: string;
  className?: string;
}

/**
 * Standardizes Phosphor icon usage to this design system's scale: always
 * "regular" weight (ui-tokens.iconSizes.strokeWidth: 1.5 documents this as
 * the chosen stroke weight) and a named size from ui-tokens.iconSizes rather
 * than a raw pixel number.
 */
export function Icon({ icon: PhosphorIconComponent, size = 'md', color = 'currentColor', className }: IconProps) {
  return <PhosphorIconComponent size={iconSizes[size]} color={color} weight="regular" className={className} />;
}
